import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./component-account/login/login.component";
import {RegisterComponent} from "./component-account/register/registration.component";
import {RegistrationConfirmationComponent} from "./component-account/confirm/confirmRegistration.component";
import {ResendCodeComponent} from "./component-account/resend/resendCode.component";
import {ForgotPassword2Component, ForgotPasswordStep1Component} from "./component-account/forgot/forgotPassword.component";
import {NewPasswordComponent} from "./component-account/newpassword/newpassword.component";
import {AboutComponent, HomeComponent} from "./component-public/home.component";
import {SecureHomeComponent} from "./component/secure-home/secure-home.component";
import {CreateDesignProjectComponent} from "./component/create-design-project/create-design-project.component";
import {CartComponent} from "./component/cart/cart.component";
import {AccountComponent} from "./component/account/account.component";
import {PaymentComponent} from "./component/account/payment/payment.component";
import {SubscriptionComponent} from "./component/account/subscription/subscription.component";
import {ProjectComponent} from "./component/editor-project/project.component";
import {ImagesComponent} from "./component/images/images.component";
import {ProductComponent} from "./component/product/product.component";
import {ShelfComponent} from "./component/shelf/shelf.component";
import {PrintNodeOrderItemsComponent} from "./component/print-node-order-items/print-node-order-items.component";
import {ManufacturingSetsComponent} from "./component/manufacturing-sets/manufacturing-sets.component";
import {CSVComponent} from "./component/csv/csv.component";
import {UsersComponent} from "./component/users/users.component";
import {OrganizationsComponent} from "./component/organizations/organizations.component";
import {UmbrellasComponent} from "./component/umbrellas/umbrellas.component";
import {PrintNodeOrdersComponent} from "./component/print-node-orders/print-node-orders.component";
import {FacilityInventoryProductsComponent} from "./component/facility-inventory-products/facility-inventory-products.component";
import {GroupOrdersComponent} from "./component/group-orders/group-orders.component";
import {ServiceProvidersComponent} from "./component/service-providers/service-providers.component";
import {FacilitiesComponent} from "./component/facilities/facilities.component";
import {ShipmentOrdersComponent} from "./component/shipment-orders/shipment-orders.component";
import {AddressIssuesComponent} from "./component/address-issues/address-issues.component";
import {LanguageComponent} from "./component-account/language/language.component";
import {SettingsComponent} from "./component/settings/settings.component";
import {BillingOrdersComponent} from "./component/billing-orders/billing-orders.component";
import {FacilityPrintNodeOrdersComponent} from "./component-facility/print-node-orders/facility-print-node-orders.component";
import {FulfillmentOrdersComponent} from "./component-facility/fulfilment-orders/fulfillment-orders.component";
import {PicksheetsComponent} from "./component-facility/picksheets/picksheets.component";
import {PrintNodeOrdersAdminComponent} from "./component/print-node-orders-admin/print-node-orders-admin.component";
import {OrganizationInvoicesComponent} from "./component/organization-invoices/organization-invoices.component";
import {FacilityInvoicesComponent} from "./component/facility-invoices/facility-invoices.component";
import {PrintNodeOrderSearchComponent} from "./component/print-node-order-search/print-node-order-search.component";
import {ProductsComponent} from "./component/products/products.component";
import {ManufacturingBucketsComponent} from "./component/manufacturing-buckets/manufacturing-buckets.component";
import {FacilityScanComponent} from "./component/facility-scan/facility-scan.component";
import {FacilityPackagesComponent} from "./component/facility-packages/facility-packages.component";
import {ManufacturingTasksComponent} from "./component/manufacturing-tasks/manufacturing-tasks.component";
import {IssuesComponent} from "./component/issues/issues.component";
import {StartupComponent} from "./component/startup/startup.component";
import {ProjectDraftComponent} from "./component/projects/draft/project-draft.component";
import {ProjectsComponent} from "./component/projects/projects.component";
import {EcommerceComponent} from "./component/ecommerce/ecommerce.component";
import {EcommerceOrdersComponent} from "./component/ecommerce-orders/ecommerce-orders.component";
import {EcommerceProductsComponent} from "./component/ecommerce-products/ecommerce-products.component";
import {NetworkSettingsComponent} from "./component/network-settings/network-settings.component";
import {FacilitySettingsComponent} from "./component/facility-settings/facility-settings.component";
import {ServiceProviderSettingsComponent} from "./component/service-provider-settings/service-provider-settings.component";
import {SelectRoleComponent} from "./component/select-role/select-role.component";
import {ProjectMappingDashboardComponent} from "./component/project-mapping/dashboard/project-mapping-dashboard.component";
import {ProjectMappingReviewComponent} from "./component/project-mapping/review/project-mapping-review.component";
import {ShopifyLinkComponent} from "./component/shopify-link/shopify-link.component";


/*
 * External entry point for the Shopify managed-install flow.
 *
 * Deliberately NOT under `/secure`: a merchant arrives here straight from
 * their Shopify admin, usually signed out, so the page has to render and
 * explain itself before any authentication exists. It handles sign-in and
 * role selection itself and comes back via
 * `StartupService.pendingPostStartupRoute`.
 *
 * Nothing else creates a Shopify EcommerceConnection -- see
 * `docs/contracts/shared/ShopifyAppInstall.md`.
 */
export const shopifyRoutes: Routes = [
  {path: 'shopify/link', component: ShopifyLinkComponent},
];

export const homeRoutes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    children: [
      {path: 'about', component: AboutComponent},
      {path: 'login', component: LoginComponent},
      {path: 'language', component: LanguageComponent},
      {path: 'register', component: RegisterComponent},
      {path: 'confirmRegistration/:username', component: RegistrationConfirmationComponent},
      {path: 'resendCode', component: ResendCodeComponent},
      {path: 'forgotPassword/:email', component: ForgotPassword2Component},
      {path: 'forgotPassword', component: ForgotPasswordStep1Component},
      {path: 'newPassword', component: NewPasswordComponent},
      {path: '', component: LoginComponent},
      {path: 'landing', component: LoginComponent}
    ]
  },
];

export const secureRoutes: Routes = [
  {

    path: '',
    redirectTo: '/secure',
    pathMatch: 'full'
  },
  {
    path: 'secure',
    component: SecureHomeComponent,
    children: [
        {path: 'account', component: AccountComponent,
          children: [
            {path: 'payment', component: PaymentComponent, outlet: 'account' },
            {path: 'subscription', component: SubscriptionComponent, outlet: 'account'}
          ]
        },
      {path: 'addressissues', component: AddressIssuesComponent },
      {path: 'adminorders', component: PrintNodeOrdersAdminComponent },
      {path: 'billingorders', component: BillingOrdersComponent },
      {path: 'cart', component: CartComponent },
      {path: 'createDesignProject', component: CreateDesignProjectComponent },
      {path: 'csv', component: CSVComponent },
      {path: 'draftbook/:ID', component: ProjectDraftComponent },
      {path: 'ecommerce', component: EcommerceComponent },
      {path: 'ecommerceorders', component: EcommerceOrdersComponent },
      {path: 'ecommerceproducts', component: EcommerceProductsComponent },
      {path: 'facilities', component: FacilitiesComponent },
      {path: 'facility-invoices', component: FacilityInvoicesComponent },
      {path: 'facilityinventory', component: FacilityInventoryProductsComponent },
      {path: 'facilitypackages', component: FacilityPackagesComponent },
      {path: 'facilityprintnodeorders', component: FacilityPrintNodeOrdersComponent },
      {path: 'facilityscan', component: FacilityScanComponent },
      {path: 'fulfillmentorders', component: FulfillmentOrdersComponent },
      {path: 'groupOrders', component: GroupOrdersComponent },
      {path: 'images', component: ImagesComponent },
      {path: 'issues', component: IssuesComponent },
      {path: 'manufacturingbuckets', component: ManufacturingBucketsComponent },
      {path: 'manufacturingsets', component: ManufacturingSetsComponent },
      {path: 'manufacturingtasks', component: ManufacturingTasksComponent },
      {path: 'networksettings', component: NetworkSettingsComponent },
      {path: 'serviceprovidersettings', component: ServiceProviderSettingsComponent },
      {path: 'facilitysettings', component: FacilitySettingsComponent },
      {path: 'orderitems', component: PrintNodeOrderItemsComponent },
      {path: 'orders', component: PrintNodeOrdersComponent },
      {path: 'ordersearch', component: PrintNodeOrderSearchComponent },
      {path: 'organization-invoices', component: OrganizationInvoicesComponent },
      {path: 'organizations', component: OrganizationsComponent },
      {path: 'picksheets', component: PicksheetsComponent },
      {path: 'products', component: ProductsComponent },
      {path: 'projects', component: ProjectsComponent },
      /*
       * Project mapping. Three paths, ONE review component.
       *
       * `projectmapping`        - operator dashboard over organizations.
       * `projectmapping/:orgId` - that dashboard's row, opened.
       * `projectreview`         - an organization reviewing its own run; the
       *                           orgId comes from the selected role and not
       *                           from the URL, so a customer cannot be
       *                           handed a link to somebody else's.
       *
       * The second and third render the SAME component against the same
       * endpoint. That is deliberate: an operator on the phone to a customer
       * must be looking at exactly what the customer is describing.
       */
      {path: 'projectmapping', component: ProjectMappingDashboardComponent },
      {path: 'projectmapping/:orgId', component: ProjectMappingReviewComponent },
      {path: 'projectreview', component: ProjectMappingReviewComponent },
      {path: 'secure', component: PrintNodeOrderSearchComponent },
      /*
       * Role picker. Lives under `/secure` so it inherits
       * `SecureHomeComponent`'s app shell (top toolbar + SideNav).
       * Data services haven't loaded yet at this point, so the
       * SideNav only exposes its always-visible Logout link (the
       * rest of the SideNav is guarded by
       * `startupService.isDataLoaded`).
       */
      {path: 'selectRole', component: SelectRoleComponent },
      {path: 'serviceproviders', component: ServiceProvidersComponent },
      {path: 'settings', component: SettingsComponent },
      {path: 'shelf', component: ShelfComponent },
      {path: 'shipmentorders', component: ShipmentOrdersComponent },
      {path: 'startup', component: StartupComponent },
      {path: 'umbrellas', component: UmbrellasComponent },
      {path: 'users', component: UsersComponent },
      {path: '', component: StartupComponent } ]
    // {path: 'admin', component: AdminComponent },
//         {path: 'testtable', component: TestTableComponent },
// {path: '', component: ShelfComponent }
// {path: 'dataSource', component: OrdersComponent },
// {path: 'orderitems', component: OrderItemsComponent },
// {path: 'product/:ID', component: ProductComponent },
// {path: 'project/:ID', component: ProjectComponent },      ]
  }
];

export const adminRoutes: Routes = [
  {
    path: '',
    redirectTo: '/admin',
    pathMatch: 'full'
  },
  {
    path: 'admin',
    component: SecureHomeComponent,
    children: [
      {path: '', component: UsersComponent},
      {path: 'adminusers', component: UsersComponent}
    ]
  },
];

const routes: Routes = [
  {
    path: '',
    children: [
      ...shopifyRoutes,
      ...homeRoutes,
      ...secureRoutes,
      ...adminRoutes,
      {
        path: '',
        component: HomeComponent
      }
    ]
  },


];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
